{
  "name": "lawyerty-fe",
  "version": "1.72.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:dev": "ng serve --configuration=dev",
    "build": "ng build",
    "build:dev": "ng build --configuration=dev",
    "build:test": "ng build --configuration=test",
    "build:prod": "ng build --configuration=prod",
    "build:production": "ng build --configuration=prod",
    "sourcemaps:upload": "npx -y @sentry/cli sourcemaps upload --org lawyerty-dev --project website --release $npm_package_version --strip-common-prefix dist/lawyerty/browser",
    "watch": "ng build --watch --configuration development",
    "lint": "ng lint",
    "lint:fix": "ng lint --fix",
    "format": "prettier --write .",
    "e2e": "ng e2e",
    "e2e:ui": "ng e2e --ui",
    "prestart:env": "node ./scripts/write-env-config.mjs",
    "start:env": "ng serve --configuration=env",
    "prebuild:env": "node ./scripts/write-env-config.mjs",
    "build:env": "ng build --configuration=env"
  },
  "private": true,
  "dependencies": {
    "@ag-grid-community/styles": "~33.0.3",
    "@angular/animations": "~21.2.25",
    "@angular/cdk": "~20.2.14",
    "@angular/common": "~21.2.25",
    "@angular/compiler": "~21.2.25",
    "@angular/core": "~21.2.25",
    "@angular/forms": "~21.2.25",
    "@angular/material": "~20.2.14",
    "@angular/platform-browser": "~21.2.25",
    "@angular/platform-browser-dynamic": "~21.2.25",
    "@angular/router": "~21.2.25",
    "@ng-bootstrap/ng-bootstrap": "~19.0.0",
    "@ngx-translate/core": "~16.0.4",
    "@ngx-translate/http-loader": "~16.0.1",
    "@popperjs/core": "~2.11.8",
    "@sentry/angular": "^10.65.0",
    "@swimlane/ngx-charts": "24",
    "ag-grid-angular": "~36.0.1",
    "ag-grid-community": "~36.0.1",
    "base64-js": "^1.5.1",
    "bootstrap": "~5.3.7",
    "client-zip": "~2.5.0",
    "date-fns": "~4.4.0",
    "exceljs": "~4.4.0",
    "html2canvas": "~1.4.1",
    "lodash": "~4.18.1",
    "pdfjs-dist": "~5.4.149",
    "rxjs": "~7.8.2",
    "tslib": "~2.8.1",
    "uuid": "~11.1.0",
    "vanilla-cookieconsent": "^3.1.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^21.2.25",
    "@angular/cli": "~21.2.25",
    "@angular/compiler-cli": "~21.2.25",
    "@angular/localize": "~21.2.25",
    "@faker-js/faker": "^10.3.0",
    "@playwright/test": "1.57.0",
    "@types/bootstrap": "~5.2.10",
    "@types/d3-array": "~3.2.1",
    "@types/d3-scale": "~4.0.9",
    "@types/d3-selection": "~3.0.11",
    "@types/d3-shape": "~3.1.7",
    "@types/dot-object": "~2.1.6",
    "@types/exceljs": "~0.5.3",
    "@types/html2canvas": "~0.5.35",
    "@types/jquery": "~3.5.32",
    "@types/lodash": "~4.17.16",
    "@types/node": "~22.20.1",
    "@types/uuid": "~9.0.8",
    "angular-eslint": "22.5.0",
    "css-loader": "~6.11.0",
    "dotenv": "^17.2.3",
    "eslint": "~9.33.0",
    "eslint-config-prettier": "~10.1.3",
    "eslint-plugin-prettier": "~5.4.0",
    "playwright-ng-schematics": "^2.0.3",
    "prettier": "~3.5.3",
    "prettier-eslint": "~16.4.2",
    "sass": "~1.87.0",
    "sass-loader": "~16.0.5",
    "typescript": "~5.9.3",
    "typescript-eslint": "8.71.0"
  },
  "packageManager": "pnpm@11.1.0"
}
